import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from 'components/common/Icon/Icon'
import Theme from 'components/common/Theme/Theme'

const SelectedFilter = ({ handleRemove, value }) =>
  <Result>
    <span data-at-selected-filter-value>{ value }</span>
    <Close
      data-at-selected-filter-clear
      asset="icon-circle-close"
      float="right"
      margin="0 -20px 0 0"
      onClick={ handleRemove } />
  </Result>

export default SelectedFilter

SelectedFilter.propTypes = {
  handleRemove: PropTypes.func,
  value: PropTypes.string
}

const Result = styled.div`
  margin: 17px 0 0;
  line-height: 19px;
  color: ${Theme.colors.black};
`

const Close = styled(Icon)`
  cursor: pointer;
`
